import { Text, Section } from '@acast/decibel';
import { resolve } from 'acast-www-utils';
import { Episode, Show } from 'client/resources';
import T from 'prop-types';
import React from 'react';
import validateEpisode from 'resources/episode/validate';
import resourceProp from 'shared/helpers/resource-prop';
import { markerPropType } from '../../../../customPropTypes';
import { validateMarker } from '../../../../shared/helpers/markers';
import AcastPlusSettings from '../acast-plus';
import PublishControls from '../publish-controls';
import PublishDateSelect from '../publish-date-select';
import ValidationErrorsAlert from '../validation-errors-alert';
import PublishStateMessage from './publish-state-message';

const createMarkerErrors = (markers, episodeDuration) => {
  const customMarkerErrors = [];
  const errors = markers.reduce((acc, marker) => {
    const markerErrors = validateMarker(marker, episodeDuration) || {};

    if (markerErrors.custom) {
      customMarkerErrors.push(markerErrors.custom);
      delete markerErrors.custom;
    }

    Object.keys(markerErrors).forEach(key => {
      // eslint-disable-next-line no-param-reassign
      acc[key] = (acc[key] || 0) + 1;
    });

    return acc;
  }, {});

  return Object.keys(errors)
    .map(key => {
      const keyName =
        {
          imageUrl: 'image URL',
          linkUrl: 'link URL',
          videoUrl: 'video URL',
        }[key] || key;

      if (errors[key] > 1) {
        return `There are ${errors[key]} markers with invalid ${keyName}.`;
      }

      return `There is a marker with invalid ${keyName}.`;
    })
    .concat(customMarkerErrors);
};

const PublishSettings = ({ markers, show, episode, episodeDuration }) => {
  const episodeErrors = validateEpisode(episode.data, markers);
  const markerErrors = createMarkerErrors(markers, episodeDuration);
  const allValidationErrors = episodeErrors.concat(markerErrors);
  const isValid = allValidationErrors.length === 0;

  function renderAcastPlusSettingsIfShowHasAnyProduct() {
    if (resolve(show, 'data.products.length') > 0) {
      return <AcastPlusSettings episode={episode} />;
    }
    return null;
  }

  return (
    <Section>
      <Text variant="h3">Publish Settings</Text>
      <PublishDateSelect episode={episode} />
      {renderAcastPlusSettingsIfShowHasAnyProduct()}
      <PublishStateMessage episode={episode} />
      <ValidationErrorsAlert validationErrors={allValidationErrors} />
      <PublishControls episode={episode} canPublish={isValid} />
    </Section>
  );
};

PublishSettings.propTypes = {
  episode: resourceProp(Episode),
  episodeDuration: T.number,
  canPublish: T.bool,
  markers: T.arrayOf(markerPropType),
  show: resourceProp(Show),
};

PublishSettings.defaultProps = {
  canPublish: false,
  markers: [],
};

export default Show.connect('show', 'showId')(PublishSettings);
